module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921131149_T.e62fbcf0.jpg";